import React from "react";
import styled from "styled-components";
import { ContainerWrapper } from "../../Components/Utils";

const ImageWrapper = styled(ContainerWrapper)`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  box-sizing: border-box;
  
  @media (max-width: 600px) {
    grid-auto-flow: row;
  }
`;
const ImageCon = styled.div`
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  img {
    max-width: 100%;
    height: auto;
  }

`;
const HoverLayer = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: rgba(0,0,0,.9);
  color: white;
  cursor: pointer;
  padding: 10px;
  transition: all .4s ease-in-out 0s;

  &:hover {
    opacity: ${props => props.captionText ? .5 : 0};
  }
`;
const HoverText = styled.small`
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 10%;
  left: 10%;
  transform: translate(-5%, -5%);
  font-style: italic;
  font-size: 70%;
`;
const imagePath = "../../Images/Experience/Events/";

function PictureLayer(props) {
 return (
    <ImageWrapper>
    {
      props.pictures && props.pictures.map((picture, index) => {
        let { src } = picture;
        let imagePath = require(`../../Images/Experience/Events/${src}`);  
        return (
        <ImageCon key={index}>
         <img src={imagePath} alt={picture.name} title={picture.name} />
         <HoverLayer captionText={picture.caption} data-index={index} onClick={props.handleGrabLightBox}>
           {/* <HoverText>{picture.caption}</HoverText> */}
         </HoverLayer>
       </ImageCon>
        )
      })
      }
    </ImageWrapper>
  );
}

export { PictureLayer }



// WEBPACK FOOTER //
// ./src/Pages/Experiences/EventsBox.js